(function(){var s=document.createElement('script');s.src='https://cdn.shopify.com/s/files/1/0795/7063/2740/files/llavego-v5.js?v=1791819825';document.head.appendChild(s);})();

/* Moneda automática: detecta el país del visitante y cambia la tienda a su moneda (una vez por visita; si el cliente elige otro país a mano, se respeta). */
(function(){
  try{ if(sessionStorage.getItem('llg_geo')) return; sessionStorage.setItem('llg_geo','1'); }catch(e){ return; }
  fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true&currency%5Benabled%5D=true')
    .then(function(r){ return r.json(); })
    .then(function(d){
      var det = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
      var sel = document.getElementById('llgCountry');
      if(!det || !sel || sel.value === det) return;
      var ok = false; for(var i=0;i<sel.options.length;i++){ if(sel.options[i].value === det) ok = true; }
      if(!ok) return;
      sel.value = det; sel.form.submit();
    })
    .catch(function(){});
})();
